import {
  HttpErrorResponse,
  type HttpEvent,
  type HttpHandlerFn,
  type HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, type Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { HttpAlertService } from '@td/components/alert/http-alert.service';
import { AuthStore } from '../stores';
import { SKIP_LTS_LOGOUT_FOR_LOGIN } from './http-context-tokens';

export function httpErrorsInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
  authStore = inject(AuthStore),
  httpAlertService = inject(HttpAlertService),
  router = inject(Router),
): Observable<HttpEvent<unknown>> {
  const skipLogout = request.context.get(SKIP_LTS_LOGOUT_FOR_LOGIN);

  return next(request).pipe(
    catchError((response) => {
      if (!(response instanceof HttpErrorResponse)) {
        return throwError(() => response);
      }

      console.warn('HTTP request failed', response);

      switch (response.status) {
        case HttpStatusCode.Unauthorized: {
          if (skipLogout) {
            httpAlertService.show(response);
            break;
          }
          authStore.logout();
          break;
        }
        case HttpStatusCode.Forbidden: {
          if (!router.url.includes('/errors/no-access')) {
            router.navigateByUrl('/errors/no-access');
          }
          break;
        }
        case HttpStatusCode.NotFound: {
          httpAlertService.show(response);
          break;
        }
        default: {
          httpAlertService.show(response);

          if (request.method === 'GET') {
            router.navigateByUrl('/errors/page-load', { skipLocationChange: true });
          }
        }
      }

      return throwError(() => response);
    }),
  );
}
